import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import { makeStyles, Box, Grid } from "@material-ui/core";
import { Text } from "../components/Text";
import colors from "../constants/colors";
import { store } from "../store";
import { drivers } from "../constants/mocks";

const Driver: FC = observer(() => {
  const classes = styles();
  const { driverName, throatExit } = store;
  const filteredDrivers = drivers.filter(
    (driver) => driver["Throat Exit"] === throatExit
  );

  return (
    <Box maxWidth={1000} maxHeight="calc(100vh - 300px)" overflow="auto">
      {filteredDrivers.map(({ "Driver Name": name, ...rest }) => (
        <Box
          key={name}
          onClick={() => (store.driverName = name)}
          className={driverName === name ? classes.active : classes.inactive}
        >
          <Text bold>{name}</Text>
          <Box className={classes.details}>
            <Grid container>
              {Object.keys(rest).map((key) => (
                <Grid key={key} item xs={6} sm={3} md={2}>
                  <Box mx={2} my={1}>
                    <Text color="secondary" bold size="small">
                      {key}
                    </Text>
                    <Text color="secondary" size="small">
                      {rest[key]}
                    </Text>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      ))}
    </Box>
  );
});

const styles = makeStyles(() => ({
  inactive: {
    padding: "12px 12px 12px 12px",
    border: "1px solid grey",
    boxShadow: "none",
    backgroundColor: "white",
    "&:nth-child(even)": {
      backgroundColor: "#F2F2F2",
    },
    "&:first-child": {
      borderRadius: "10px 10px 0px 0px",
    },
    "&:last-child": {
      borderRadius: "0px 0px 10px 10px",
    },
    "&:before": {
      display: "none",
    },
  },
  active: {
    padding: "12px 12px 12px 12px",
    border: "2px solid red",
    boxShadow: "none",
    backgroundColor: "white",
    "&:nth-child(even)": {
      backgroundColor: "#F2F2F2",
    },
    "&:first-child": {
      borderRadius: "10px 10px 0px 0px",
    },
    "&:last-child": {
      borderRadius: "0px 0px 10px 10px",
    },
    "&:before": {
      display: "none",
    },
  },
  next: {
    width: "100%",
    position: "fixed",
    right: 0,
    bottom: 0,
    background: "white",
    display: "flex",
    justifyContent: "flex-end",
    padding: 10,
  },
  driver: {
    fontWeight: "bold",
    color: colors.dark,
  },
  details: {
    margin: "10px 0px 5px",
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap",
  },
}));

export default Driver;
